import { render, staticRenderFns } from "./GoogleReCaptchaV3.vue?vue&type=template&id=378e0f58&"
import script from "./GoogleReCaptchaV3.vue?vue&type=script&lang=js&"
export * from "./GoogleReCaptchaV3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports